export enum GTagEvents {
  PURCHASE = "purchase",
  REMOVE_FROM_CART = "remove_from_cart",
  ADD_TO_CART = "add_to_cart",
  SIGN_UP = "sign_up",
  VIEW_ITEM = "view_item",
  VIEW_ITEM_LIST = "view_item_list",
  SELECT_ITEM = "select_item",
  VIEW_CART = "view_cart",
  BEGIN_CHECKOUT = "begin_checkout",
  ADD_PAYMENT_INFO = "add_payment_info",
  ADD_SHIPPING_INFO = "add_shipping_info",
  LOGIN = "login",
}

export type ProductDataLayerType = {
  item_id: string; // Reference
  item_name: string;
  index: number;
  item_brand: string;
  item_category: string;
  item_variant: string;
  price: number;
  quantity?: number;
  coupon?: string;
};

export const valueFormatter = (value: string): number => {
  return parseFloat(value.replace(/[^\d.,]/g, "").replace(",", "."));
};

export const calculateTax = (
  totalIncludingTax: string,
  totalExcludingTax: string,
): number => {
  return (
    Math.round(
      (valueFormatter(totalIncludingTax) - valueFormatter(totalExcludingTax)) *
        100,
    ) / 100
  );
};

export const calculateValue = (
  totalExcludingTax: string,
  shipping: string,
  netto: boolean = false,
): number => {
  const checkedShipping = shipping === "Za darmo!" ? "0" : shipping;
  let baseValue = valueFormatter(totalExcludingTax.toString());

  if (netto) {
    baseValue = baseValue / 1.23;
  }

  return Math.round((baseValue - valueFormatter(checkedShipping)) * 100) / 100;
};
